import { memo } from 'react';

/**
 * Ideal shape for the HealthIndicator.
 * @internal
 */
export const IdealShape = memo(() => {
  return (
    <svg
      focusable="false"
      role="img"
      aria-hidden="true"
      fill="currentColor"
      width="12"
      height="12"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12 12"
    >
      <path d="M2 6C2 4.93913 2.42143 3.92172 3.17157 3.17157C3.92172 2.42143 4.93913 2 6 2C7.06087 2 8.07828 2.42143 8.82843 3.17157C9.57857 3.92172 10 4.93913 10 6C10 7.06087 9.57857 8.07828 8.82843 8.82843C8.07828 9.57857 7.06087 10 6 10C4.93913 10 3.92172 9.57857 3.17157 8.82843C2.42143 8.07828 2 7.06087 2 6Z" />
    </svg>
  );
});

/**
 * Good shape for the HealthIndicator.
 * @internal
 */
export const GoodShape = memo(() => {
  return (
    <svg
      focusable="false"
      role="img"
      aria-hidden="true"
      fill="currentColor"
      width="12"
      height="12"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12 12"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 6C3.5 6.66304 3.76339 7.29893 4.23223 7.76777C4.70107 8.23661 5.33696 8.5 6 8.5C6.66304 8.5 7.29893 8.23661 7.76777 7.76777C8.23661 7.29893 8.5 6.66304 8.5 6C8.5 5.33696 8.23661 4.70107 7.76777 4.23223C7.29893 3.76339 6.66304 3.5 6 3.5C5.33696 3.5 4.70107 3.76339 4.23223 4.23223C3.76339 4.70107 3.5 5.33696 3.5 6ZM6 2C4.93913 2 3.92172 2.42143 3.17157 3.17157C2.42143 3.92172 2 4.93913 2 6C2 7.06087 2.42143 8.07828 3.17157 8.82843C3.92172 9.57857 4.93913 10 6 10C7.06087 10 8.07828 9.57857 8.82843 8.82843C9.57857 8.07828 10 7.06087 10 6C10 4.93913 9.57857 3.92172 8.82843 3.17157C8.07828 2.42143 7.06087 2 6 2Z"
      />
    </svg>
  );
});

/**
 * Warning shape for the HealthIndicator.
 * @internal
 */
export const WarningShape = memo(() => {
  return (
    <svg
      focusable="false"
      role="img"
      aria-hidden="true"
      fill="currentColor"
      width="12"
      height="12"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12 12"
    >
      <path d="M5.12701 2.49996C5.21549 2.34795 5.34275 2.22172 5.49599 2.13396C5.64923 2.0462 5.82306 2 6 2C6.17694 2 6.35077 2.0462 6.50401 2.13396C6.65725 2.22172 6.78451 2.34795 6.87299 2.49996L10.3649 8.49996C10.4534 8.65197 10.5 8.82441 10.5 8.99995C10.5 9.17548 10.4534 9.34793 10.365 9.49994C10.2765 9.65196 10.1492 9.7782 9.99598 9.86597C9.84274 9.95374 9.66891 9.99995 9.49196 9.99996H2.50804C2.33109 9.99995 2.15726 9.95374 2.00402 9.86597C1.85078 9.7782 1.72352 9.65196 1.63505 9.49994C1.54658 9.34793 1.5 9.17548 1.5 8.99995C1.5 8.82441 1.54658 8.65197 1.63506 8.49996L5.12701 2.49996Z" />
    </svg>
  );
});

/**
 * Critical shape for the HealthIndicator.
 * @internal
 */
export const CriticalShape = memo(() => {
  return (
    <svg
      focusable="false"
      role="img"
      aria-hidden="true"
      fill="currentColor"
      width="12"
      height="12"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12 12"
    >
      <rect
        x="6"
        y="1"
        width="7.07106"
        height="7.07106"
        rx="1"
        transform="rotate(45 6 1)"
      />
    </svg>
  );
});

/**
 * Neutral shape for the HealthIndicator.
 * @internal
 */
export const NeutralShape = memo(() => {
  return (
    <svg
      focusable="false"
      role="img"
      aria-hidden="true"
      fill="currentColor"
      width="12"
      height="12"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 12 12"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.7804 9.9246C6.26539 10.0265 5.73541 10.0265 5.2204 9.9246L5.5104 8.4526C5.83392 8.51673 6.16688 8.51673 6.4904 8.4526L6.7804 9.9246ZM3.7784 9.3266L4.6124 8.0806C4.33876 7.89732 4.10367 7.66223 3.9204 7.3886L2.6744 8.2226C2.96631 8.65954 3.34145 9.03468 3.7784 9.3266ZM2.0764 6.7816L3.5484 6.4906C3.48427 6.16708 3.48427 5.83411 3.5484 5.5106L2.0764 5.2206C1.97453 5.73561 1.97453 6.26658 2.0764 6.7816ZM2.6744 3.7786L3.9204 4.6126C4.1034 4.3396 4.3394 4.1036 4.6124 3.9206L3.7784 2.6746C3.34182 2.96695 2.96675 3.34202 2.6744 3.7786ZM5.2194 2.0766C5.73506 1.97447 6.26574 1.97447 6.7814 2.0766L6.4904 3.5486C6.16688 3.48447 5.83392 3.48447 5.5104 3.5486L5.2194 2.0766ZM8.2224 2.6746L7.3884 3.9206C7.6614 4.1036 7.8974 4.3396 8.0804 4.6126L9.3264 3.7786C9.03404 3.34202 8.65898 2.96695 8.2224 2.6746ZM9.9244 5.2196L8.4524 5.5106C8.51653 5.83411 8.51653 6.16708 8.4524 6.4906L9.9244 6.7806C10.0263 6.26558 10.0263 5.73461 9.9244 5.2196ZM9.3264 8.2226L8.0804 7.3886C7.89713 7.66223 7.66203 7.89732 7.3884 8.0806L8.2224 9.3266C8.65898 9.03424 9.03404 8.65918 9.3264 8.2226Z"
      />
    </svg>
  );
});
